var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFtCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 2H22V0h-2v4h4.5c.8 0 1.5.7 1.5 1.5V8H2V5.5C2 4.7 2.7 4 3.5 4H8V0H6v2H3.5C1.6 2 0 3.6 0 5.5V10h28V5.5C28 3.6 26.4 2 24.5 2zM26 26H2V12H0v16h28V12h-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2h8v2h-8zM19.2 13.3l-5.3 6.2-3.2-3.2-1.4 1.4 4.8 4.8 6.7-7.8z"
  })));
}
export default SvgFtCalendar;